(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function safeParseInt(value) {
    var n = parseInt(String(value || '').trim(), 10);
    return Number.isFinite(n) ? n : NaN;
  }

  function formatTime(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function initCountdown(rootEl) {
    if (!rootEl) return;

    // each instance keeps its own interval id stored on the element
    if (rootEl.__countdown_initialized) return;
    rootEl.__countdown_initialized = true;

    var totalSeconds = safeParseInt(rootEl.dataset.totalSeconds);
    if (isNaN(totalSeconds) || totalSeconds < 0) {
      console.warn('[Countdown] invalid totalSeconds on', rootEl, 'value:', rootEl.dataset.totalSeconds);
      totalSeconds = 0;
    }

    var displayDays = rootEl.querySelector('[data-countdown-display="days"]');
    var displayHours = rootEl.querySelector('[data-countdown-display="hours"]');
    var displayMinutes = rootEl.querySelector('[data-countdown-display="minutes"]');
    var displaySeconds = rootEl.querySelector('[data-countdown-display="seconds"]');

    function render(secondsLeft) {
      var days = Math.floor(secondsLeft / 86400);
      var hours = Math.floor((secondsLeft % 86400) / 3600);
      var minutes = Math.floor((secondsLeft % 3600) / 60);
      var seconds = secondsLeft % 60;

      if (displayDays) displayDays.textContent = formatTime(days);
      if (displayHours) displayHours.textContent = formatTime(hours);
      if (displayMinutes) displayMinutes.textContent = formatTime(minutes);
      if (displaySeconds) displaySeconds.textContent = formatTime(seconds);
    }

    // initial render
    render(totalSeconds);

    // if zero, nothing to tick
    if (totalSeconds <= 0) return;

    // Clear prior interval if somehow set
    if (rootEl.__countdown_interval) {
      clearInterval(rootEl.__countdown_interval);
    }

    rootEl.__countdown_interval = setInterval(function () {
      if (totalSeconds <= 0) {
        clearInterval(rootEl.__countdown_interval);
        render(0);
        return;
      }
      totalSeconds -= 1;
      render(totalSeconds);
    }, 1000);
  }

  function initAll() {
    var nodes = document.querySelectorAll('.countdown-timer');
    if (!nodes || nodes.length === 0) {
      console.info('[Countdown] no .countdown-timer instances found.');
      return;
    }
    nodes.forEach(initCountdown);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init if editor or dynamic renderer replaces DOM (safe & debounced)
  var debounce;
  var observer = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(initAll, 120);
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-career-button"] && !Shopify.designMode) return;
  try {
      

const ctaButton = document.querySelector('#career__btn');

if (ctaButton) {
  ctaButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation?.();

    // find the target by class (first instance)
    const target = document.querySelector('#crmWebToEntityForm');

    if (!target) {
      console.warn('Footer-event section not found (id #crmWebToEntityForm)');
      return;
    }

    // Scroll using GSAP if available, otherwise native smooth scroll
    if (typeof gsap !== 'undefined' && typeof ScrollToPlugin !== 'undefined') {
      gsap.registerPlugin(ScrollToPlugin);
      gsap.to(window, { duration: 1.2, scrollTo: { y: target, offsetY: 80 }});
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // optionally offset for header height:
      // window.scrollBy({ top: -80, behavior: 'smooth' });
    }
  }, { passive: false });
}


  } catch(e) { console.error(e); }
})();
})();
